if (!customElements.get("product-carousel")) {
  class a extends HTMLElement {
    constructor() {
      super();
      var e = this.querySelector(".swiper-scrollbar"),
        r = this.querySelector(".arrow--left"),
        s = this.querySelector(".arrow--right"),
        parseOption = (value, fallback) => {
          if (value === "auto") return value;

          var parsed = parseFloat(value);

          return Number.isNaN(parsed) ? fallback : parsed;
        },
        slidesMobile = parseOption(this.dataset.slidesMobile, 1),
        slidesSmall = parseOption(this.dataset.slidesSmall, 2),
        slidesTablet = parseOption(this.dataset.slidesTablet, 3),
        slidesDesktop = parseOption(this.dataset.slidesDesktop, 3),
        spaceMobile = parseOption(this.dataset.spaceMobile, 8),
        spaceTablet = parseOption(this.dataset.spaceTablet, 16),
        spaceDesktop = parseOption(this.dataset.spaceDesktop, 16),
        // Zapetlenie jest opcjonalne per karuzela: bez atrybutu zostaje
        // dotychczasowe zachowanie (koniec listy = wygaszona strzalka).
        //
        // Swiadoma decyzja: obracamy karuzele przewinieciem na poczatek (rewind),
        // a NIE trybem loop Swipera. Loop wymaga zapasu slajdow poza widokiem;
        // przy szerokosci kart liczonej z arkusza (slidesPerView: "auto") tego
        // zapasu nie ma i zamiast zawijac, karuzela odbija miedzy dwoma
        // ostatnimi zaczepieniami, a strzalka przestaje cokolwiek robic.
        // Rewind dziala niezaleznie od liczby kart i szerokosci ekranu.
        rewind = this.dataset.loop === "true",
        // Samoczynne przesuwanie wlacza sie tylko z atrybutem (wartosc w
        // milisekundach). Nie ruszamy go, gdy uzytkownik prosi system o
        // ograniczenie animacji - dla niego karuzela zostaje nieruchoma.
        autoplayDelay = parseFloat(this.dataset.autoplay),
        spokojnyRuch = window.matchMedia("(prefers-reduced-motion: reduce)").matches,
        autoplayWlaczony = !Number.isNaN(autoplayDelay) && autoplayDelay > 0 && !spokojnyRuch,
        // Po siegnieciu przez odwiedzajacego przesuwanie milczy tyle czasu, a
        // potem wraca samo. Bez atrybutu: dwa i pol odstepu autoplay.
        autoplayPauza = parseOption(this.dataset.autoplayResume, autoplayDelay * 2.5),
        autoplay = autoplayWlaczony
          ? {
              delay: autoplayDelay,
              // Karuzela chodzi bez przerwy: kursor jej nie zatrzymuje, a
              // siegniecie przez odwiedzajacego nie gasi jej na stale.
              // Wstrzymanie po strzalce i powrot po czasie robimy nizej sami,
              // bo Swiper zna tylko "gas na zawsze" (disableOnInteraction).
              disableOnInteraction: !1,
              pauseOnMouseEnter: !1,
            }
          : !1,
        swiper = new Swiper(this.querySelector(".swiper-container"), {
          autoplay: autoplay,
          loop: !1,
          rewind: rewind,
          grabCursor: !1,
          speed: 500,
          spaceBetween: spaceMobile,
          slidesPerView: slidesMobile,
          watchSlidesProgress: !0,
          scrollbar: { el: e, enabled: !0 },
          navigation: { nextEl: s, prevEl: r },
          breakpoints: {
            430: { spaceBetween: spaceMobile, slidesPerView: slidesSmall },
            768: { spaceBetween: spaceTablet, slidesPerView: slidesTablet },
            1200: { spaceBetween: spaceDesktop, slidesPerView: slidesDesktop },
          },
        });

      if (!autoplayWlaczony) return;

      var powrot,
        wstrzymajNaChwile = () => {
          window.clearTimeout(powrot);
          swiper.autoplay.stop();
          powrot = window.setTimeout(() => {
            if (swiper && !swiper.destroyed) swiper.autoplay.start();
          }, autoplayPauza);
        };

      // Strzalki na desktopie i gest palcem na telefonie - jedno i drugie
      // znaczy "czytam sam", wiec przesuwanie ma zamilknac na chwile.
      if (r) r.addEventListener("click", wstrzymajNaChwile);
      if (s) s.addEventListener("click", wstrzymajNaChwile);
      swiper.on("touchEnd", wstrzymajNaChwile);
      swiper.on("scrollbarDragEnd", wstrzymajNaChwile);
    }
  }
  customElements.define("product-carousel", a);
}
